import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * Importing paper component types
 */
import { Gp1Tp1Component } from '../../core-modules/paper-layouts/group/gp1-tp1/gp1-tp1.component';
import { Gp1Tp2Component } from '../../core-modules/paper-layouts/group/gp1-tp2/gp1-tp2.component';
import { Gp1Tp3Component } from '../../core-modules/paper-layouts/group/gp1-tp3/gp1-tp3.component';
import { Gp1Tp4Component } from '../../core-modules/paper-layouts/group/gp1-tp4/gp1-tp4.component';
import { Gp1Tp5Component } from '../../core-modules/paper-layouts/group/gp1-tp5/gp1-tp5.component';

import { Gp2Tp1Component } from '../../core-modules/paper-layouts/group/gp2-tp1/gp2-tp1.component';
import { Gp2Tp2Component } from '../../core-modules/paper-layouts/group/gp2-tp2/gp2-tp2.component';
import { Gp2Tp3Component } from '../../core-modules/paper-layouts/group/gp2-tp3/gp2-tp3.component';
import { Gp2Tp4Component } from '../../core-modules/paper-layouts/group/gp2-tp4/gp2-tp4.component';
import { Gp2Tp5Component } from '../../core-modules/paper-layouts/group/gp2-tp5/gp2-tp5.component';
import { Gp2Tp6Component } from '../../core-modules/paper-layouts/group/gp2-tp6/gp2-tp6.component';
import { Gp2Tp7Component } from '../../core-modules/paper-layouts/group/gp2-tp7/gp2-tp7.component';

import { Gp2Tp5rComponent } from '../../core-modules/paper-layouts/group/gp2-tp5r/gp2-tp5r.component';

import { In1Tp1Component } from '../../core-modules/paper-layouts/individual/in1-tp1/in1-tp1.component';
import { In1Tp2Component } from '../../core-modules/paper-layouts/individual/in1-tp2/in1-tp2.component';
import { In1Tp3Component } from '../../core-modules/paper-layouts/individual/in1-tp3/in1-tp3.component';
import { In1Tp4Component } from '../../core-modules/paper-layouts/individual/in1-tp4/in1-tp4.component';

import { In2Tp1Component } from '../../core-modules/paper-layouts/individual/in2-tp1/in2-tp1.component';
import { In2Tp2Component } from '../../core-modules/paper-layouts/individual/in2-tp2/in2-tp2.component';
import { In2Tp3Component } from '../../core-modules/paper-layouts/individual/in2-tp3/in2-tp3.component';
import { In2Tp4Component } from '../../core-modules/paper-layouts/individual/in2-tp4/in2-tp4.component';
import { In2Tp5Component } from '../../core-modules/paper-layouts/individual/in2-tp5/in2-tp5.component';
import { In2Tp6Component } from '../../core-modules/paper-layouts/individual/in2-tp6/in2-tp6.component';

import {LayoutMainComponent} from '../../core-modules/paper-layouts/layout-main/layout-main.component';

// import { ShapeOptions, LineProgressComponent, CircleProgressComponent, SemiCircleProgressComponent} from 'angular2-progressbar';

@NgModule({
  imports: [  
    CommonModule
  ],
  declarations: [
    Gp1Tp1Component,
    Gp1Tp2Component,
    Gp1Tp3Component,
    Gp1Tp4Component,
    Gp1Tp5Component,

    Gp2Tp1Component,
    Gp2Tp2Component,
    Gp2Tp3Component,
    Gp2Tp4Component,
    Gp2Tp5Component,
    Gp2Tp5rComponent,
    Gp2Tp6Component,
    Gp2Tp7Component,

    In1Tp1Component,
    In1Tp2Component,
    In1Tp3Component,
    In1Tp4Component,

    In2Tp1Component,
    In2Tp2Component,
    In2Tp3Component,
    In2Tp4Component,
    In2Tp5Component,
    In2Tp6Component,
    // CircleProgressComponent,
    LayoutMainComponent,
  ],
  exports:[
    Gp1Tp1Component,
    Gp1Tp2Component,
    Gp1Tp3Component,
    Gp1Tp4Component,
    Gp1Tp5Component,

    Gp2Tp1Component,
    Gp2Tp2Component,
    Gp2Tp3Component,
    Gp2Tp4Component,
    Gp2Tp5Component,
    Gp2Tp6Component,
    Gp2Tp7Component,

    Gp2Tp5rComponent,

    In1Tp1Component,
    In1Tp2Component,
    In1Tp3Component,
    In1Tp4Component,

    In2Tp1Component,
    In2Tp2Component,
    In2Tp3Component,
    In2Tp4Component,
    In2Tp5Component,
    In2Tp6Component,
    // CircleProgressComponent,
    LayoutMainComponent,]
})
export class PaperTemplateModule { }



// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/shared/modules/paper-template.module.ts